import { UserClient } from '@frontend/user/api';
import { IUser } from '@frontend/user/types';
import { useCallback, useEffect, useState } from 'react';

export interface SupervisedUsersCardProps {
    account_id: string;
    entity_id: string;
}

export const useSupervisedUsersCard = (props: SupervisedUsersCardProps) => {
    const [users, setUsers] = useState<IUser[]>([]);

    const fetchUsers = useCallback(async () => {
        const response = await UserClient.fetchSupervisedUsers(props.account_id, props.entity_id);
        setUsers(response.results);
    }, [props.account_id, props.entity_id]);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    return {
        users
    };
};
